export default __webpack_public_path__ + "static/prem_bitkowski-6b5391cd4d01183aa66fa30405e01f74.png";